import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { antiWebHookApi } from "../http/Api";

export const getAntiWebHook = createAsyncThunk('AntiWebHook/getAntiWebHook', async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiWebHookApi.getAntiWebHook(serverId);
    console.log('response', response);

    if(response.status === 200) {
        thunkAPI.dispatch(antiWebHookSlice.actions.setAntiWebHook(response))
    }
})

export const getAntiWebHookLogs = createAsyncThunk('AntiWebHook/getAntiWebHookLogs', async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiWebHookApi.getLogs(serverId);
    console.log('response', response);

    if(response.status === 200) {
        thunkAPI.dispatch(antiWebHookSlice.actions.setAntiWebHookLogs(response))
    }
})

const initialState = {
    antiWebHookGlobalState: null,
    antiWebHookLogsState: null
}

const antiWebHookSlice = createSlice({
    name: 'antiWebHook',
    initialState,
    reducers: {
        setAntiWebHook: (state, action) => {
            state.antiWebHookGlobalState = action.payload
        },
        setAntiWebHookLogs: (state, action) => {
            state.antiWebHookLogsState = action.payload
        }
    }
})

export const antiWebHook = antiWebHookSlice.reducer;
export const {setAntiWebHook} = antiWebHookSlice.actions;
